<template>
	<div class="header">
		<div class="warp">
			<a href="https://www.oda.org.cn" class="logo"></a>
			<ul class="nav">
				<li @click="gopage('https://www.oda.org.cn')" class="active">
					东方设计奖
				</li>
			</ul>

			<ul class="tool" v-show="!info.token">
				<li @click="gopage('Workadd')">
					作品上传
				</li>
				<li @click="gopage('https://college.oda.org.cn')">
					院校管理
				</li>
				<li @click="gopage('Index')" class="active">
					注册/登录
				</li>
			</ul>

			<ul class="tool" v-show="info.token">
				<li>
					<img v-if="info.avatar" :src="info.avatar" />
					<img v-else src="../assets/avater.jpg" />
					你好,{{info.name}}
				</li>
				<li @click="logout" class="logout">
					退出登录
				</li>
				<li @click="gopage('https://www.oda.org.cn/About/38.html')">
					帮助
				</li>
				<li @click="gopage('https://www.oda.org.cn')">
					首页
				</li>
			</ul>
		</div>
	</div>
	
	<div class="mobile_tell">
		<div class="txt">
			为了保证您的正常参赛，请使用电脑端登录网站
		</div>
	</div>
</template>

<script>
	export default {
		name: 'HeaderInc',
		props: {
			info: {
				token: '',
				avatar: '',
				name: ''
			}
		},
		data() {
			return {
			}
		},
		methods: {
			logout() {
				var that = this
				localStorage.removeItem("userinfo");
				that.$router.isBack = true
				that.$router.push({
					name: 'Index'
				})
			},
			gopage(str) {
				var that = this
				if (str.indexOf('https') >= 0) {
					window.location.href = str
				} else {
					that.$router.push({
						name: str
					})
				}
			}
		}
	}
</script>

<style>
	.header {
		width: 100%;
		height: 100px;
		display: block;
		overflow: hidden;
	}

	.header a.logo {
		width: 279px;
		height: 46px;
		margin-top: 27px;
		display: block;
		background: url(../assets/logo.png) no-repeat center;
		background-size: cover;
		float: left;
		position: relative;
		margin-left: 7%;
	}

	.header ul.nav,
	.header ul.tool {
		width: auto;
		height: 100px;
		display: block;
		float: left;
		margin: 0;
	}

	.header ul.tool {
		margin-left: 10%;
		vertical-align: middle;
		float: right;
	}

	.header ul.nav li,
	.header ul.tool li {
		width: auto;
		height: 40px;
		line-height: 40px;
		display: inline-block;
		list-style: none;
		margin: 30px 15px;
		cursor: pointer;
		vertical-align: middle;

	}

	.header ul.nav li.active {
		color: #bc963a;
		border-bottom: 2px solid #bc963a;
	}

	.header ul.tool li.active {
		color: #bc963a;
	}

	.header ul.tool li img {
		width: 40px;
		height: 40px;
		display: inline-block;
		vertical-align: middle;
	}

	.logout {
		background: url(../assets/ico_5.png) no-repeat left;
		background-size: auto 18px;
		padding-left: 24px;
	}
	
	.mobile_tell{
		display: none;
	}
	@media screen and (max-width: 750px) {
		.mobile_tell{
			width: 100%;
			height: 100vh;
			display: block;
			position: fixed;
			z-index: 9;
			top: 0;
			background:rgba(0,0,0,0.5);
		}
		.mobile_tell .txt{
			width: 80%;
			left: 10%;
			top: 30vw;
			color: #FFF;
			font-size: 24px;
			text-align: center;
			display: block;
			position: relative;
		}
	}
</style>
